import { LumenButton } from '@photoshelter/socialie-components';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface Props {
  checked: boolean;
  onChange: () => void;
  isSelectMode: boolean;
}

export default function SubmissionThumbnailCheckbox(props: Props) {
  const { checked, onChange, isSelectMode } = props;
  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        'dark absolute top-1 left-1 z-10 opacity-0 transition-opacity duration-250 group-hover:opacity-100',
        isSelectMode && 'opacity-100'
      )}
    >
      <LumenButton
        color={checked ? 'primary' : 'secondary'}
        size="sm"
        leftIcon="checkcircle-outline"
        onClick={onChange}
        aria-label={
          checked
            ? t('ugcRequestShow.submissions.thumbnail.deselectSubmission')
            : t('ugcRequestShow.submissions.thumbnail.selectSubmission')
        }
      />
    </div>
  );
}
